import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import moment from "moment";
import { registerLocale } from "react-datepicker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from "date-fns/locale/fr";
import { getDataByID } from "../../../../utils/fetchData";
// import "react-datepicker/dist/react-datepicker.css";

registerLocale("fr", fr);
moment.updateLocale("fr", {
  week: {
    dow: 1, // Monday is the first day of the week.
  },
});
const LineChart = ({ auth }) => {
  const [date, setDate] = useState(new Date());
  const [count, setCount] = useState([]);
  const [stat, setStat] = useState([]);

  let labels = [
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    "Dimanche",
  ];

  useEffect(() => {
    if (auth?.user?.id && date) {
      getDataByID(
        `statfichebybeneficaire/${auth?.user?.id}`,
        moment(date).format("DD-MM-YYYY"),
        auth?.token
      )
        .then((response) => {
          // console.log("stat fiche", response);
          setStat(response);
        })
        .catch((error) => console.error(error));
    }
  }, [auth, date]);

  let data = {
    labels: labels,
    datasets: [
      {
        type: "line",
        label: "Fiche de Soin",
        data: count,
        fill: false,
        backgroundColor: "#06DED1",
        borderColor: "#06DED1",
        hoverBackgroundColor: "#06DED1",
        hoverBorderColor: "#06DED1",
        yAxisID: "y-axis-1",
      },
    ],
  };

  let options = {
    responsive: true,
    labels: labels,
    tooltips: {
      mode: "label",
    },
    elements: {
      line: {
        fill: false,
      },
    },
    scales: {
      xAxes: [
        {
          display: true,
          gridLines: {
            display: false,
          },
          labels: labels,
        },
      ],
      yAxes: [
        {
          type: "linear",
          display: true,
          position: "left",
          id: "y-axis-1",
          gridLines: {
            display: false,
          },
          labels: {
            show: true,
          },
        },
        {
          type: "linear",
          display: false,
          position: "right",
          id: "y-axis-2",
          gridLines: {
            display: false,
          },
          labels: {
            show: true,
          },
        },
      ],
    },
  };

  let plugins = [
    {
      afterDraw: (chartInstance, easing) => {
        //const ctx = chartInstance.chart.ctx;
        //ctx.fillText("This text drawn by a plugin", 100, 100);
      },
    },
  ];

  useEffect(() => {
    let days = [0, 0, 0, 0, 0, 0, 0];
    if (stat?.length) {
      stat.forEach((element) => {
        days[moment(element.day).locale("fr").day()] = element.fiche;
      });
    }

    setCount(days);
  }, [stat?.length, stat]);

  const handleChangeDate = (date) => {
    // setCount([]);
    setDate(date);
    // setStat(
    //   props.stat?.filter((st) =>
    //     moment(st?.day).locale("fr").isSame(date, "week")
    //   )
    // );
  };
  return (
    <div className="chart-item-container">
      <div className="row mb-2">
        <div className="col-xl-5 col-lg-4 mb-2">
          {/* <h2 className="chart-item-title">Chiffre du jour - <span className="fw-300"> Nombre d'apprenants par jour </span> </h2> */}
        </div>
        <div className="col-xl-6 col-lg-6 col-md-4 col-sm-6 mb-2 dis-flex">
          {/* <select
            className="form-select form-select-line-chart ml-md-auto"
            aria-label="Default select example"
          >
            <option selected>Semaine du 01/01/2021</option>
            <option value="1">Semaine du 07/01/2021</option>
            <option value="2">Semaine du 14/01/2021</option>
            <option value="3">Semaine du 21/01/2021</option>
          </select> */}
          <div className="ml-desktop">
            <DatePicker
              dateFormat="dd/MM/yyyy"
              className="form-select form-select-line-chart ml-md-auto"
              selected={date}
              onChange={(date) => handleChangeDate(date)}
              locale="fr"
            />
          </div>
        </div>
      </div>
      <Bar data={data} options={options} plugins={plugins} />
    </div>
  );
};

export default LineChart;
